import { Configuration } from "../sdk";
import {
  ArtrackAdminApi,
  ArtrackTracksApi,
  ArtrackWaypointsApi,
  ArtrackAuthApi,
  ArtrackSyncApi,
  ArtrackGpsApi,
  ArtrackSegmentsApi,
} from "../sdk";

// Compute base path. Our OpenAPI paths already include "/artrack/...",
// so in dev we use basePath "/api" (vite proxy), in prod we default to the real API host.
const env: any = (import.meta as any).env || {};
const hostname = (typeof window !== 'undefined' && window.location) ? window.location.hostname : '';
const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
const defaultBase = isLocal ? '/api' : 'https://api-artrack.arkturian.com';
// Allow override via env
const rawBase: string = env.VITE_API_BASE || defaultBase;
// Normalize basePath to avoid double "/artrack" when SDK paths already include it
const trimmed = rawBase.replace(/\/$/, "");
const basePath: string = trimmed.endsWith("/artrack") ? trimmed.slice(0, -"/artrack".length) : trimmed;
// API key: prefer env, fallback to localStorage for runtime configuration
const storedKey = (typeof window !== 'undefined' && (window as any).localStorage) ? localStorage.getItem('ADMIN_API_KEY') : null;
const apiKey: string | undefined = env.VITE_ADMIN_API_KEY || storedKey || undefined;

export const sdkConfig = new Configuration({
  basePath,
  baseOptions: {
    headers: {
      ...(apiKey ? { "X-API-KEY": apiKey } : {}),
      "Content-Type": "application/json",
    },
  },
});

export const adminApi = new ArtrackAdminApi(sdkConfig);
export const tracksApi = new ArtrackTracksApi(sdkConfig);
export const waypointsApi = new ArtrackWaypointsApi(sdkConfig);
export const authApi = new ArtrackAuthApi(sdkConfig);
export const syncApi = new ArtrackSyncApi(sdkConfig);
export const gpsApi = new ArtrackGpsApi(sdkConfig);
export const segmentsApi = new ArtrackSegmentsApi(sdkConfig);

export const getApiKey = (): string | undefined => apiKey;
